import React, { cloneElement } from "react";

import {
  Tab,
  TabHeader,
  TabHeaders,
  Tabs,
} from "@transfr-inc/dashboard-components";

import { Product } from "@transfr-inc/dashboard-components/constants";
import { getProduct } from "@transfr-inc/dashboard-components/utils";
import { CareersSection } from "./careers.section";
import { DisciplinesSection } from "./disciplines.section";
import { ProgramSection } from "./programs.section";
import { TrekSection } from "./trek.section";

import { productIdParser } from "@utils/search-params-parsers";
import { useQueryState } from "nuqs";
import "./products.tabs.scss";

export const ProductsTabs = ({ organization }) => {
  const [productId, setProductId] = useQueryState("productId", productIdParser);
  const { products = [] } = organization;

  const getProductsTabs = () => {
    return products?.sort().map((p) => {
      const { id, displayName } = getProduct(p);
      const name = id.toString();
      return {
        name,
        header: (
          <TabHeader name={name}>
            <div className="tab-header-text">{displayName}</div>
          </TabHeader>
        ),
        content: (
          <Tab name={name} className="content-wrapper">
            {id === Product.TS && (
              <DisciplinesSection organization={organization} />
            )}
            {id === Product.CE && (
              <CareersSection organization={organization} />
            )}
            {id === Product.TRK && <TrekSection organization={organization} />}
            {process.env.PROGRAMS_ENABLED.toLowerCase() === "true" &&
              id === Product.PROG && (
                <ProgramSection organization={organization} />
              )}
          </Tab>
        ),
      };
    });
  };

  const tabs = getProductsTabs();

  return (
    <Tabs
      className={"products-tabs"}
      selectedTabName={productId || tabs[0].name}
    >
      <TabHeaders onSelectedTabChange={setProductId}>
        {tabs.map(({ header, name }, i) =>
          cloneElement(header, { key: `tab-header-${name}-${i}` }),
        )}
      </TabHeaders>
      {tabs.map(({ content, name }, i) =>
        cloneElement(content, { key: `tab-content-${name}-${i}` }),
      )}
    </Tabs>
  );
};
